import { useEffect, useRef, useState } from 'react'
import { apiJson, resolveImageUrl } from '../../lib/api'
import { ui } from './shared'

interface Asset { r2_key: string; mime: string; size_bytes: number; uploaded_at: number }

export function MediaManager() {
  const [rows, setRows] = useState<Asset[]>([])
  const [loading, setLoading] = useState(true)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const fileRef = useRef<HTMLInputElement>(null)

  async function load() {
    setLoading(true)
    try {
      const r = await apiJson<{ rows: Asset[] }>('/api/admin/media')
      setRows(r.rows)
    } catch (err) { setError(String(err)) }
    finally { setLoading(false) }
  }

  useEffect(() => { void load() }, [])

  async function upload(files: FileList) {
    setBusy(true); setError(null)
    try {
      for (const f of Array.from(files)) {
        const form = new FormData()
        form.append('file', f)
        const r = await fetch('/api/admin/media', {
          method: 'POST', credentials: 'same-origin', body: form,
        })
        if (!r.ok) throw new Error(`upload ${r.status}`)
      }
      await load()
    } catch (err) { setError(String(err)) }
    finally { setBusy(false) }
  }

  async function del(key: string) {
    if (!confirm(`Eliminare ${key}?`)) return
    try {
      await fetch(`/api/admin/media/${encodeURI(key)}`, { method: 'DELETE', credentials: 'same-origin' })
      await load()
    } catch (err) { setError(String(err)) }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <h1 style={ui.sectionTitle}>Media</h1>
        <div>
          <input ref={fileRef} type="file" accept="image/*" multiple style={{ display: 'none' }}
                 onChange={(e) => {
                   if (e.target.files?.length) { void upload(e.target.files); e.target.value = '' }
                 }} />
          <button type="button" style={ui.btn} disabled={busy} onClick={() => fileRef.current?.click()}>
            {busy ? 'Carico…' : '+ Carica'}
          </button>
        </div>
      </div>

      {error && <div style={{ color: '#a33', marginTop: 12 }}>{error}</div>}
      {loading && <div style={{ color: 'var(--fg-muted)', marginTop: 12 }}>Carico…</div>}

      <div style={{
        marginTop: 16,
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
        gap: 10,
      }}>
        {rows.map((a) => (
          <div key={a.r2_key} style={{ ...ui.card, padding: 10 }}>
            <img src={resolveImageUrl(a.r2_key)} alt=""
                 style={{ width: '100%', aspectRatio: '1', objectFit: 'cover', display: 'block', background: 'var(--paper)' }} />
            <div style={{
              fontSize: 10, letterSpacing: '0.18em', textTransform: 'uppercase',
              color: 'var(--fg-soft)', marginTop: 8, wordBreak: 'break-all',
            }}>{a.r2_key.split('/').pop()}</div>
            <div style={{ fontSize: 11, color: 'var(--fg-soft)', marginTop: 4 }}>
              {Math.round(a.size_bytes / 1024)} KB
            </div>
            <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
              <button type="button" style={{ ...ui.btnGhost, padding: '4px 8px', fontSize: 10 }}
                      onClick={() => navigator.clipboard?.writeText(`/api/media/${a.r2_key}`)}>Copia URL</button>
              <button type="button" style={{ ...ui.btnDanger, padding: '4px 8px', fontSize: 10 }}
                      onClick={() => del(a.r2_key)}>×</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
